var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2C5.62109 2 4.5 3.12109 4.5 4.5V8.25H7V4.5H15.8555L17 5.64453V8.25H19.5V5.64453C19.5 4.98047 19.2383 4.34375 18.7695 3.875L17.625 2.73047C17.1562 2.26172 16.5195 2 15.8555 2H7ZM17 15.75V17V19.5H7V17V16.375V15.75H17ZM19.5 17H20.75C21.4414 17 22 16.4414 22 15.75V12C22 10.6211 20.8789 9.5 19.5 9.5H4.5C3.12109 9.5 2 10.6211 2 12V15.75C2 16.4414 2.55859 17 3.25 17H4.5V19.5C4.5 20.8789 5.62109 22 7 22H17C18.3789 22 19.5 20.8789 19.5 19.5V17ZM18.875 13.5625C18.3555 13.5625 17.9375 13.1445 17.9375 12.625C17.9375 12.1055 18.3555 11.6875 18.875 11.6875C19.3945 11.6875 19.8125 12.1055 19.8125 12.625C19.8125 13.1445 19.3945 13.5625 18.875 13.5625Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintSolid);
export default __webpack_public_path__ + "static/media/print-solid.4586865003256fea1e624b48e8141bd5.svg";
export { ForwardRef as ReactComponent };